import React from 'react'
import NavbarComponent from '../component/NavbarComponent'

const HolidaysList = () => {
  return (
    <React.Fragment>
    <NavbarComponent />
    <div className="lg:p-10  pl-3 pr-3 pb-3">
      <div className="relative w-full overflow-x-auto shadow-md sm:rounded-lg">
        
        <table className="min-w-full border text-center">
          <thead className="border-b">
            <tr><td  colSpan={5}><div className="text-3xl w-full text-center uppercase  text-white py-3 bg-[#335377] font-semibold">
         List of holidays - 2023
        </div></td></tr>
            <tr className="bg-gray-100">
              <th className="py-3 text-lg"> SL.NO.</th>
              <th className="py-3 text-lg"> FESTIVALS / VACATIONS</th>
              <th className="py-3 text-lg">DAYS</th>
              <th className="py-3 text-lg">DATE</th>
              <th className="py-3 text-lg">NO. OF DAYS</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                01
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               MAKAR SANKRANTI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                SATURDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               14-01-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                02
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               SAIL DAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           TUESDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            24-01-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                03
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               REPUBLIC DAY / BASANT PANCHAMI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               26-01-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                04
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             MAHA SHIVRATRI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             SATURDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            18-02-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                05
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               SABE-E-BARAT
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                TUESDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               07-03-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                06
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               HOLI / DOL YATRA
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              WEDNESDAY TO THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             08-03-2023 TO 09-03-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           02
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                07
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               SARHUL
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               23-03-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                08
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               RAM NAVMI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            30-03-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                09
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               MAHAVIR JAYANTI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               04-04-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                10
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              GOOD FRIDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              FRIDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            07-04-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                11
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               AMBEDKAR JAYANTI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               FRIDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               14-04-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                12
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              JAMAT-UL-VIDA
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             FRIDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            21-04-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                13
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               ID-UL-FITR
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                SATURDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               22-04-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                14
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            BUDDHA PURNIMA
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
        FRIDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            05-05-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                15
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             SUMMER VACATION
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                MONDAY TO THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               15-05-2023 TO 15-06-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               28
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                16
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               ID-UN-ZOHA
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            29-06-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                17
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             MUHARRAM
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                SATURDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               29-07-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                18
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               INDEPENDENCE DAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           TUESDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            15-08-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                19
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               RAKSHA BANDHAN
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                WEDNESDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               30-08-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                20
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               JANMASTAMI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            07-09-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                21
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               MILAD-UL-NABI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               28-09-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                22
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               GHANDHI JAYANTI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
        MONDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            02-10-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                23
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           DURGA PUJA
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              FRIDAY TO TUESDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               20-10-2023 TO 24-10-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               04
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                24
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               DEEPAWALI / BHAI DOOJ
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           MONDAY TO THURSDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            13-11-2023 TO 14-11-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           02
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                25
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              BIRSA JAYANTI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
              WEDNESDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               15-11-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                26
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               CHHATH PUJA
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
         FRIDAY TO SATURDAY 
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            17-11-2023 TO 18-11-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           01
              </td>
            </tr>
            <tr className="border-b">
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                27
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
             GURUNANAK JAYANTI
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                MONDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               27-11-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
               01
              </td>
            </tr>
            <tr className="border-b bg-gray-100">
            <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
                28
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
          CHRISTMAS HOLIDAYS
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           SATURDAY TO SATURDAY
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
            23-12-2023 TO 30-12-2023
              </td>
              <td className="lg:py-3 py-1 text-md font-medium text-gray-900 border-r">
           07
              </td>
            </tr>
     
          </tbody>
        </table>
      </div>
        <div>
            <span className='font-bold'>NOTE : </span> 
            NEW YEAR DAY (01-01-2023) VISHWAKARMA PUJA (17-09-2023) AND DEEPAWALI fall on Sunday Asterisked(*)
            Festival days depend on sighting of the moon
        </div>
    </div>

    <footer className="border-t-2">
 <div className="text-center font-bold p-6 bg-white">
      <span className="text-black">© 2022 - </span>
      <span
        className="text-black text-lg font-bold hover:text-blue-300 "
      
      >
        BISSS-8B
      </span>
      <span className="text-black">
        , Education Department, Bokaro Steel Plant
      </span>
    </div>
 </footer>
</React.Fragment>
  )
}

export default HolidaysList